"use client";
import React, { useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";
import { getLink, Routes } from "@/constants";
import Cookies from "js-cookie";
import { countryLanguageMapV2 } from "./CountryLanguageMapV2";

const SUPPORTED_LOCALES = ["en", "es", "pt"] as const;

export function Culture() {
  const { currentUser, locale, setLocale } = useContext(
    AppContext
  ) as AppContextType;
  const languageOptions = countryLanguageMapV2.gb;
  const selectedLanguage = languageOptions.find((language) => language.code === locale);

  const handleChange = (code: string) => {
    if (!SUPPORTED_LOCALES.includes(code as (typeof SUPPORTED_LOCALES)[number])) return;
    setLocale(code);
    Cookies.set("locale", code, { expires: 365 });

    const link = currentUser?.uid
      ? getLink(code, Routes.DASHBOARD_COURSES)
      : getLink(code, Routes.HOMEPAGE);

    window.location.href = link;
  };
  return (
    <div className="culture-wrapper">
      {selectedLanguage && (
        <Dropdown className="culture-dropdown">
          <Dropdown.Toggle
            variant="light"
            id="culture-dropdown"
            value={locale}
            active={selectedLanguage.code === locale}
          >
            {/* <span className={`fi fi-${selectedLanguage.countryCode} me-2`} /> */}
            {selectedLanguage.name}
          </Dropdown.Toggle>

          <Dropdown.Menu className="culture-menu">
            {languageOptions.map((lang) => (
              <Dropdown.Item
                key={lang.code}
                onClick={() => handleChange(lang.code.toLocaleLowerCase())}
              >
                {lang.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
}
